<template>
  <div class="row mt-5" v-if="data">
     <div class="col-md-12 col-lg-12 col-xl-9 mt-3" :class="isReversed ? 'order-md-2' : 'order-md-1'" style="min-height:575px">

      <!-- Popular queries -->
      <div class="innerBox h-100">
        <h5 class="mb-2">{{ type == 'DEALER' ? 'Top 10 ' : '' }}{{ title }} In Transit</h5>
        <div class="d-flex row">
          <stock-in-transit-bar-chart
            v-if="data"
            class="w-100"
            :data="data"
          ></stock-in-transit-bar-chart>
        </div>
      </div>
      <!-- / Popular queries -->
    </div>
    <div class="col-md-12 col-lg-12 col-xl-3 mt-3" :class="isReversed ? 'order-md-1' : 'order-md-2'">
      <div class="row" style="height:20%">
        <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12" style="height:100%">
            <!-- <b-card no-body class="mb-4">
              <b-card-header class="border-0 pb-0">Total Intransit</b-card-header>
              <b-card-body class="text-center text-success text-xlarge py-3">3,235</b-card-body>
            </b-card> -->
            <div class="stats-inner-box mb-4" :style="(stats_color != null) ? 'background-color:' + stats_color : 'background-color: #348FE2'">
              <div class="row" style="height: 100%">
                <div class="col-8">
                  <p>Total {{title}}</p>
                  <p class="stats-value">
                    {{numberWithCommas(total)}}
                    <!-- 5000 -->
                  </p>
                </div>
                <div class="col-4 icon">
                  <i class="fas fa-motorcycle"></i>
                </div>
              </div>
            </div>
        </div>
      </div>
      <!-- Stats -->
      <div class="innerBox" style="height: 80%;">
        <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12"  style="height:100%">
          <h4 class="text-center">Intransit Summary</h4>
          <table class="table">
            <thead>
              <th>{{(type == 'MAINDEALER') ? 'Destination' : 'From'}}</th>
              <th>Total</th>
            </thead>
            <tbody>
              <tr v-for="data in tableData">
                <td>{{type=='MAINDEALER' ? data.tujuan : data.start}}</td>
                <td>{{numberWithCommas(data.count)}}</td>
              </tr>
            </tbody>
        </table>
        </div>
      </div>
      <!-- / Stats -->
    </div>
  </div>
</template>

<script>
  import stockInTransitBarChart from './stockInTransitBarChart'

  export default {
    data () {
      return {
        isReversed : false,
        data : null,
        tableData : null,
        total : 0,
      }
    },
    props : ['filterUrl', 'api_url', 'title', 'reverse', 'stats_color', 'type'],
    components : {
      stockInTransitBarChart
    },
    mounted () {
      if(this.reverse != null && typeof this.reverse == 'boolean') this.isReversed = this.reverse;
    },
    watch : {
      filterUrl : {
        handler(){
          if(this.filterUrl != null && this.filterUrl != ''){
            this.fetchData()
          }
        },
        immediate : true
      }
    },
    methods : {
      fetchData(){
        this.total = 0;

        this.$http.get(this.api_url + "?" + this.filterUrl)
        .then((resp)=>{
          var data = resp.data.data;

          if(this.type == 'MAINDEALER'){
            for (var i in data) {
              this.total += data[i].count;
            }
            this.data = data;
            this.tableData = data;
          } else {
            this.total = data.total;
            this.data = data.stock;
            this.tableData = data.summary;
          }
        })
        .catch((err)=>{
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>

</style>